import { FC } from 'react';

import { getRequestedLanguages } from '../../locale/languages';
import { ColorClothingProduct } from '../../utils/models/product';

interface Props {
    colors: ColorClothingProduct[];
    selectedColor: ColorClothingProduct;
    onSelectColor: (id: string) => void;
}

const ColorSelectorComponent: FC<Props> = ({ colors, selectedColor, onSelectColor }) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);

    return (
        <div className="br-colorSelector">
            <p className="br-colorSelector__label">{language.product.clothing_selector.color}</p>
            <div className="br-colorSelector__list">
                {colors.map((color) => {
                    return (
                        <div
                            key={`color-${color.label}-${color.id}`}
                            className={`br-colorSelector__list--item ${color.id == selectedColor.id && '-selected'}`}
                            onClick={() => {
                                onSelectColor(color.id);
                            }}
                        >
                            <img src={color.img} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ColorSelectorComponent;
